<ng-container *ngIf="!phxDropdownTemplate else options">
  <div #addonTrigger class="phx-addon-content" [ngClass]="phxAlignment">
    <ng-content></ng-content>
  </div>
</ng-container>

<ng-template #options>
  <div #addonTrigger
    class="phx-addon-content phx-pointer-cursor phx-has-options"
    [phxDropdownFor]="phxDropdownTemplate"
    [attr.tabindex]="disabled ? null : 0"
    [ngClass]="phxAlignment"
    phxTrigger="click"
    [phxPosition]="phxDropdownPosition"
    [(phxVisible)]="phxOpen"
    (phxVisibleChange)="onVisibleChanged($event)"
  >
    <div class="phx-addon-content-text">
      {{ phxSelectedOption }}
    </div>
    <i phx-icon [phxIcon]="ChevronUpDownIcon" [size]="16"></i>
  </div>
</ng-template>
